import Panel from "../conponents/common/Panel";
import Equipment from "../conponents/water/Equipment";
import InstantDetail from "../conponents/common/InstantDetail";
import { MultiChart } from "../conponents/common/SafeChart";
import { useEffect, useState } from "react";
import { selectChartDataByType } from "../store/informationSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectAuth } from "../store/authSlice";
import { fetchEquipment, fetchInfoData } from "../store/informationSlice";

function Water() {
  const dispatch = useDispatch();
  const chartData = useSelector(selectChartDataByType(1));
  const [currentLayer, setCurrentLayer] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  const isAuth = useSelector(selectAuth);

  useEffect(() => {
    if (isAuth) {
      dispatch(fetchEquipment({ mode: 2 }));
      dispatch(fetchInfoData({ mode: 2, date: selectedTime }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 配置圖表數據
  const charts = [
    {
      key: "second_data",
      data: chartData?.second_data,
      title: chartData?.second_data?.option?.title,
    },
    {
      key: "main_data",
      data: chartData?.data,
      title: chartData?.data?.option?.title,
    },
  ];

  return (
    <>
      <Panel>
        <InstantDetail
          currentLayer={currentLayer}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
        />
      </Panel>
      <Panel>
        <Equipment
          setCurrentLayer={setCurrentLayer}
          selectedTime={selectedTime}
        />
      </Panel>
      <Panel>
        <MultiChart charts={charts} layout="horizontal" />
      </Panel>
    </>
  );
}

export default Water;
